<template>
  <div id="app">
    <Grid />
    <Pointer />
    <Loader />
    <Logo />
    <Burger />
    <Language />
    <Menu />
    <Slider />
    <Webgl />

    <main class="a-main">
      <transition
        v-bind:css="false"
        v-on:enter="enter"
        v-on:after-enter="afterEnter"
        v-on:leave="leave"
      >
        <router-view />
      </transition>
    </main>
  </div>
</template>

<style lang="scss">
@import "~@/main.scss";
</style>

<script>
import Sniffer from 'sniffer';

// utils
import Scroll from '@/utils/scroll';
import Effects from '@/utils/effects';
import Transitions from '@/utils/transitions';

// components
import Grid from '@/components/grid/grid.vue';
import Pointer from '@/components/pointer/pointer.vue';
import Loader from '@/components/loader/loader.vue';
import Logo from '@/components/logo/logo.vue';
import Burger from '@/components/burger/burger.vue';
import Language from '@/components/language/language.vue';
import Menu from '@/components/menu/menu.vue';
import Slider from '@/components/slider/slider.vue';
import Webgl from '@/components/webgl/webgl.vue';

// app
import { app } from '@/utils/store';

// init
Sniffer.addClasses(document.documentElement);

export default {
  components: {
    Grid,
    Pointer,
    Loader,
    Logo,
    Burger,
    Language,
    Menu,
    Slider,
    Webgl,
  },
  methods: {
    leave(el, done) {
      setTimeout(() => {
        app.transitions.leave(el, done);
      }, 50);

      app.scroll.off();
      app.effects.off();
      app.pointer.off();
    },
    enter(el, done) {
      setTimeout(() => {
        app.transitions.enter(el, done);
      }, 50);
    },
    afterEnter(el) {
      app.transitions.afterEnter(el);

      setTimeout(() => {
        app.scroll = new Scroll();
        app.scroll.init();

        app.effects = new Effects();
        app.effects.init();

        app.transitions = new Transitions();
        app.transitions.init();

        app.pointer.events();
      }, 50);
    },
  },
  mounted() {
    this.$nextTick(() => {
      app.scroll = new Scroll();
      app.scroll.init();

      app.effects = new Effects();
      app.effects.init();

      app.transitions = new Transitions();
      app.transitions.init();
    });
  },
};
</script>
